"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const ThemeContext_1 = require("../../../interface/ThemeContext");
const email_1 = require("../../../redux/reducers/email");
const react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
const connector = (0, react_redux_1.connect)((state) => ({}), (dispatch) => {
    return {
        sendSupportEmail(data) {
            dispatch((0, email_1.supportTicket)(data));
        },
    };
});
exports.default = connector(({ sendSupportEmail }) => {
    const themeContext = (0, ThemeContext_1.useThemeContext)();
    const currentColor = themeContext.colors.white;
    const [submitted, setSubmitted] = (0, react_1.useState)({
        clicked: false,
        submitted: false,
    });
    const [formData, setFormData] = (0, react_1.useState)({
        name: "",
        email: "",
        phone: "",
        type: "General Support",
        otherDescription: "",
        question: "",
    });
    const handleChange = ({ target: { name, value }, }) => {
        setFormData(Object.assign(Object.assign({}, formData), { [name]: value }));
    };
    return (react_1.default.createElement("div", { className: "ticket-outer-container", id: "support-ticket-container" },
        react_1.default.createElement("div", { className: "ticket-form-container container", style: {
                maxWidth: 640,
            } },
            react_1.default.createElement("div", { className: "contact-us-form-header mb-0" },
                react_1.default.createElement("h3", null, "Submit a Support Ticket"),
                react_1.default.createElement("p", null, submitted.submitted ? (react_1.default.createElement(react_1.default.Fragment, null,
                    "Thank you for submitting a support ticket! We've received your request and will be in touch within 24 hours. We appreciate your patience and look forward to assisting with you. ",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    "If you need immediate assistance please email",
                    " ",
                    react_1.default.createElement("a", { href: "mailto:help@swivvl.com" }, "help@swivvl.com"))) : ("Your thoughts and feedback are important to us. Please leave your details and message in the fields below, and we'll be in touch."))),
            react_1.default.createElement("form", { className: "ticket-form container", style: {
                    display: submitted.submitted ? "none" : "flex",
                } },
                react_1.default.createElement("div", { className: "ticket-form-input-container" },
                    react_1.default.createElement("label", null, "Full Name"),
                    react_1.default.createElement("input", { type: "text", placeholder: "Name Surname", name: "name", onChange: handleChange, value: formData.name })),
                react_1.default.createElement("div", { className: "ticket-form-input-container" },
                    react_1.default.createElement("label", null, "E-Mail"),
                    react_1.default.createElement("input", { type: "text", placeholder: "Email", name: "email", onChange: handleChange, value: formData.email })),
                react_1.default.createElement("div", { className: "ticket-form-input-container" },
                    react_1.default.createElement("label", { htmlFor: "ticket-form-phone" }, "Phone"),
                    react_1.default.createElement(react_phone_input_2_1.default
                    //  class="number"
                    , { 
                        //  class="number"
                        containerStyle: {
                            width: "100%",
                        }, specialLabel: "", inputClass: "form-control", country: "us", value: formData.phone, onChange: (phone) => setFormData(Object.assign(Object.assign({}, formData), { phone })) })),
                react_1.default.createElement("div", { className: "ticket-form-input-container" },
                    react_1.default.createElement("label", { htmlFor: "ticket-form-type" }, "Type"),
                    react_1.default.createElement("select", { id: "ticket-form-type", name: "type", value: formData.type, onChange: handleChange },
                        react_1.default.createElement("option", { value: "General Support" }, "General Support"),
                        react_1.default.createElement("option", { value: "Billing" }, "Billing"),
                        react_1.default.createElement("option", { value: "Integration" }, "Integration"),
                        react_1.default.createElement("option", { value: "My Account" }, "My Account"),
                        react_1.default.createElement("option", { value: "Other" }, "Other")),
                    formData.type === "Other" && (react_1.default.createElement("input", { type: "text", placeholder: "Description", name: "otherDescription", onChange: handleChange, value: formData.otherDescription }))),
                react_1.default.createElement("div", { className: "ticket-form-input-container" },
                    react_1.default.createElement("label", null, "Question"),
                    react_1.default.createElement("textarea", { placeholder: "Question", name: "question", onChange: handleChange, value: formData.question })),
                react_1.default.createElement("button", { onClick: (e) => {
                        e.preventDefault();
                        setSubmitted({ submitted: false, clicked: true });
                        sendSupportEmail({
                            body: formData,
                            cb() {
                                var _a;
                                setSubmitted({ submitted: true, clicked: false });
                                (_a = document
                                    .getElementById("support-ticket-container")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                            },
                        });
                    } }, submitted.clicked ? (react_1.default.createElement("div", { className: "spinner-border", role: "status" },
                    react_1.default.createElement("span", { className: "visually-hidden" }, "..."))) : ("Send"))))));
});
